// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"d8996957","332":"7070ff03","404":"e48bdf3d","437":"d8996957"}[chunkId] + ".chunk.css";
};